// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1YPTi","backBtn":"styles_backBtn__aaypz"};